<template>
	<defaultTemplate>
		<b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
		<div class="card rounded">
			<div class="card-content text-left pd-1">
				<div class="columns flex-warp">
					<div class="column is-4  text-center" v-for="(data,index) in formList" v-if="formList.length > 0" :key="index">
						<div class="bordered rounded pd-3" >
							<div class="box-circle-logo  mg-x-auto mg-y-3" >
				              <i class="fas fa-file-alt fa-lg"></i>
				            </div>
							<p :title="data.name" class="word-ellipsis mg-y-1"><span class="has-text-weight-bold">ชื่อฟอร์ม: </span>{{data.name}}</p>
							<div class="text-center mg-t-2 pd-b-2">
					        	<button type="submit" class="button submit" :style="styleObject" @click="setDataTheme(data)">
						        	ดูรายละเอียด
						        </button>
					        </div>
						</div>
					</div>
					<div class="column text-center" v-else>
						 <h1>กรุณาติดต่อเจ้าหน้าที่</h1>
					</div>
				</div>
			</div>
		</div>
	</defaultTemplate>
</template>
<script>
import defaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";
	export default{
		components: {
        	defaultTemplate
    	},
    	computed:{
    		user(){
    			return this.$store.state.user
			},
    	},
    	mounted(){
            if(this.formData.length == 0){
                this.$router.push('/wait-form')
            }
            if(this.user.userLevel < 60){
                this.setDefaultTheme()
            }
		    this.dataForm()
    	},
    	methods:{
    		setDataTheme(data){ 
                this.$store.commit('SET_COLUMN',[])
    			if(this.user.userLevel == 80){
    				this.$router.push(`/form-data-list/${data._id}`)
    			}else if(this.user.userLevel == 60){
    				this.$router.push(`/form-data-list/${data._id}`)
    			}else{
					let filter = this.formData.filter(filter => filter.formId == data._id)
					if (filter.length > 0) {
						this.$router.push(`/form-data-list/${data._id}/${filter[0].assignedBy}`)
                        let user = {
                            _id:filter[0].assignedBy
                        }
                        this.setTheme(user)
					}
    			}
    		},
    		dataForm(){
    			HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
    			this.formData.map((data,index)=>{
					if(typeof data != 'undefined'){
						HTTP.get(`get/form/${data.formId}`).then(res=>{
							console.log(`get/form/${data.formId}`,res)
							if(res.data.success){
								this.formList.push(res.data.obj.obj.form)
								this.isLoading = false
							}else{
								this.isLoading = false
							}
						}).catch((e)=>{
							this.isLoading = false
							console.log(`get/form/${data.formId} error`,e);
						}).finally(()=>{
							this.isLoading = false
						})
					}
    			})
    			
    		}
    	},
    	data(){
    		return {
				isLoading:true,
    			formList:[]
    		}
    	}
	}
</script>